import {inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {getAvailableLanguages} from '../../assets/i18n/available-languages';
import {BehaviorSubject, Observable} from 'rxjs';
import {MarketService} from './market.service';
import {AuthService} from './auth.service';
import {getStored, setStored} from '../utils/other/utilities';

@Injectable({
    providedIn: 'root'
})
export class FnpLanguageService {

    public updateLanguage$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    private readonly CACHED_LANGUAGE = 'CACHED_LANGUAGE';
    private readonly _translateService: TranslateService = inject(TranslateService);
    private readonly _marketService: MarketService = inject(MarketService);
    private readonly _authService: AuthService = inject(AuthService);

    public translate(key: string): string {
        return key! ? this._translateService.instant(key) : key;
    }

    public use(langCode: string): Observable<any> {
        const validLang: string = getAvailableLanguages(this._authService.isCurrentlyLogged() ? this._marketService.currentMarket?.shortname : null).find(lang => lang.code?.toLowerCase().startsWith(langCode?.toLowerCase()))?.code
            ?? this._translateService.getDefaultLang();
        this.updateLanguage$.next(validLang);
        setStored(this.CACHED_LANGUAGE, langCode);
        return this._translateService.use(validLang);
    }

    public get currentLang(): string {
        return this._translateService.currentLang ?? this.cachedLanguage ?? this._translateService.getDefaultLang();
    }

    public get cachedLanguage(): string {
        return getStored(this.CACHED_LANGUAGE);
    }
}
